<template>
  <div class="tab-item-content">
    <div class="search-layout">
      <template v-if="!expanded">
        <div class="item-wrap long">
          <el-input
            size="small"
            placeholder="业务人员ID/业务人员手机号/真实姓名"
            v-model.trim="formRef.nameLike"
            clearable
          />
        </div>
      </template>
      <template v-else>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="业务人员ID"
            v-model.trim="formRef.salesJobNumber"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="业务员手机号"
            v-model.trim="formRef.contactInformation"
            clearable
          />
        </div>
        <div class="item-wrap">
          <el-input
            size="small"
            placeholder="真实姓名"
            v-model.trim="formRef.truthName"
            clearable
          />
        </div>
        <!-- <div class="item-wrap">
          <el-input
            size="small"
            placeholder="订单号"
            v-model="formRef.truthName"
            clearable
          />
        </div> -->
        <div class="item-wrap">
          <el-select
            v-model="formRef.withdrawType"
            clearable
            placeholder="提现状态"
            size="small"
          >
            <el-option
              v-for="item in withdrawTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item-wrap long-small">
          <el-date-picker
            size="small"
            v-model="withdrawTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="提现时间-开始"
            end-placeholder="提现时间-结束"
          >
          </el-date-picker>
        </div>
      </template>
      <div class="item-wrap op">
        <el-button size="small" @click="resetForm">重置</el-button>
        <el-button type="primary" size="small" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="text" size="small" @click="handleExpand()">
          {{ expanded ? "收起" : "展开"
          }}<i
            :class="{
              'el-icon-arrow-up': expanded,
              'el-icon-arrow-down': !expanded,
              'el-icon--right': true,
            }"
          ></i>
        </el-button>
      </div>
    </div>
    <div class="table-wrap">
      <MyTable
        :table-data="tableData"
        @sort-change="sortChange"
        :index="index"
        :selection="selection"
        :page="page"
        :operation="false"
        :table-option.sync="tableOption"
        @page-change="getList"
      >
      </MyTable>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import { queryWithdrawalStatement } from "@/api/externalSalesRule/index.js";
import dayjs from "dayjs";

export default {
  components: {
    MyTable,
  },
  props: {
    salesJobNumber: {
      default: "",
    },
  },
  data() {
    return {
      expanded: false,

      withdrawTypeList: [
        { label: "发起", value: "INITIATE" },
        { label: "完成", value: "COMPLETE" },
        { label: "失败", value: "LOSE" },
        { label: "已退票", value: "REFUNDED_TICKET" },
      ], 
      withdrawTime: "", 
      formRef: {
        nameLike: "", //业务人员ID/业务人员手机号/真实姓名/身份证号/银行卡号
        salesJobNumber: "", //业务员工号/就是页面上的业务员id
        contactInformation: "", //业务员手机号
        truthName: "", //真实姓名
        withdrawType: "", //	提现状态（INITIATE：发起，COMPLETE：完成，LOSE：失败，REFUNDED_TICKET：已退票）
        sortTag: "", //	排序标识，1：提现时间正序，2：提现时间倒序，3：金额正序，4：金额倒序
        withdrawStartTime: "", //认证时间-开始时间
        withdrawEndTime: "", //	认证时间-结束时间
      },

      tabsIndex: "-1",
      operation: true,
      selection: false,
      index: false,
      tableData: [],
      tableOption: [
        {
          label: "提现时间",
          prop: "withdrawTime",
          sortable: "custom",
          minWidth: 120,
          sortNum: 1,
        },
        { label: "业务人员ID", prop: "salesJobNumber", minWidth: 120 },
        { label: "业务人员手机号", prop: "contactInformation", minWidth: 120 },
        { label: "真实姓名", prop: "truthName", minWidth: 120 },
        {
          label: "提现金额",
          prop: "amount",
          sortable: "custom",
          minWidth: 120,
          sortNum: 3,
          type:'money'
        },
        {
          label: "状态",
          prop: "status",
          minWidth: 120,
        },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 50, 100],
      },
    };
  },
  created() {
    this.formRef.nameLike = this.salesJobNumber;
    this.getList();
  },
  methods: {
    handleExpand() {
      this.expanded = !this.expanded;
    },
    currentChange(val) {
      console.log("current", val);
    },
    sortChange(val) {
      /**
       * 排序标识，1：认证时间正序，2：认证时间倒序
       */
      if (val.order) {
        const findedItem = this.tableOption.find(
          (item) => item.prop === val.prop
        );
        if (findedItem && findedItem.sortNum) {
          if (val.order == "ascending") {
            ////升序
            this.formRef.sortTag = findedItem.sortNum;
          } else {
            this.formRef.sortTag = findedItem.sortNum + 1;
          }
        }
      } else {
        const findedItem = this.tableOption.find(
          (item) => item.prop === val.prop
        );
        if (findedItem) {
          this.formRef.sortTag = "";
        }
      }
      this.getList();
    },
    getList() {
      const { current, size } = this.page;
      let params = {
        current,
        size,
        sortTag: this.formRef.sortTag,
      };
      //认证时间
      if (this.withdrawTime) {
        this.formRef.withdrawStartTime = dayjs(this.withdrawTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formRef.withdrawEndTime = dayjs(this.withdrawTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }

      if (this.expanded) {
        _.merge(params, this.formRef);
        params.nameLike = "";
      } else {
        params.nameLike = this.formRef.nameLike;
      }

      queryWithdrawalStatement(params).then((data) => {
        if (data) {
          const { records, total } = data;
          this.page.total = total;
          this.tableData = records;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
    handleSearch() {
      this.page.current = 1;
      this.getList();
    },
    resetForm() {
      let sortTag = this.formRef.sortTag;
      for (let key in this.formRef) {
        this.formRef[key] = "";
      }
      this.formRef.sortTag = sortTag;

      this.withdrawTime = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/index.scss";

.statics {
  display: flex;
  flex-direction: row;

  .item {
    width: 120px;
    height: 80px;
    background: #f5222d;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:not(:first-child) {
      margin-left: 8px;
    }

    .tip {
      font-size: 12px;
      font-weight: 400;
      text-align: left;
      color: #ffffff;
    }

    .value {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      color: #ffffff;
      margin-top: 4px;
      max-width: 96%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
